import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import {
  provideClientHydration, withEventReplay, withHttpTransferCacheOptions
} from '@angular/platform-browser';
import {
  provideRouter, withComponentInputBinding, withInMemoryScrolling, withNavigationErrorHandler
} from '@angular/router';
import { provideAsyncInit } from '@unimarket/shared';

import { routes } from './app.routes';
import { CartService } from './service/cart.service';
import { pageFailed } from './service/page-failure';

/**
 * Lets the browser reuse what the server already fetched, instead of asking for the page and the
 * cart a second time while it hydrates.
 *
 * Angular leaves such calls out by default, because ours carry the visitor's cookie and their
 * answers would be wrong to hand to anybody else. Here they end up inside a page that is already
 * rendered for that one visitor, so they add nothing that was not in it already. An answer that
 * sets a cookie is still left out, and the browser asks for it itself.
 */
const transferCache = withHttpTransferCacheOptions({
  includeRequestsWithAuthHeaders: true,
  includeRequestsWithCredentials: true
});

export const appConfig: ApplicationConfig = {
  providers: [
    // No zone.js: every value the templates read is a signal, so Angular is told what changed
    // instead of having to guess from patched browser APIs.
    provideZonelessChangeDetection(),
    provideHttpClient(withFetch()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      // Anchor scrolling is what makes the '#product-list' suffix on every filter link work.
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withNavigationErrorHandler(pageFailed)
    ),
    provideClientHydration(withEventReplay(), transferCache),
    provideAsyncInit(CartService)
  ]
};
